export enum NavigateMode {
  none = 0,
  InternalLink = 1,
  ExternalLink = 2,
  BannerInternalLink = 7,
  BannerNone = 8,
  BannerExternalLink=3,
  Play = 9
}
